/*flag-options*/
/*--api-url*/
/*--yes*/
/*--scope-scope*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "link",
  "description": "`turbo link` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "将仓库链接到远程缓存提供程序。"
  }, {
    "heading": "",
    "content": "¥Link the repository to a Remote Cache provider."
  }, {
    "heading": "",
    "content": "选定的所有者（用户或组织）将能够通过 远程缓存 共享 缓存工件。"
  }, {
    "heading": "",
    "content": "¥The selected owner (either a user or an organization) will be able to share cache artifacts through Remote Caching."
  }, {
    "heading": "标志选项-flag-options",
    "content": "¥Flag options"
  }, {
    "heading": "--api-url---api-url",
    "content": "指定远程缓存提供程序的 URL。"
  }, {
    "heading": "--api-url---api-url",
    "content": "¥Specifies the URL of your Remote Cache provider."
  }, {
    "heading": "--yes---yes",
    "content": "对所有提示回答“是”"
  }, {
    "heading": "--yes---yes",
    "content": "¥Answer yes to all prompts"
  }, {
    "heading": "--scope-scope---scope-scope",
    "content": "你要链接的范围。例如，在使用 Vercel 时，这是你的 Vercel 团队的 slug。"
  }, {
    "heading": "--scope-scope---scope-scope",
    "content": "¥The scope to which you are linking. For example, when using Vercel, this is your Vercel team's slug."
  }],
  "headings": [{
    "id": "标志选项-flag-options",
    "content": "标志选项 /*flag-options*/"
  }, {
    "id": "--api-url---api-url",
    "content": "--api <url> /*--api-url*/"
  }, {
    "id": "--yes---yes",
    "content": "--yes /*--yes*/"
  }, {
    "id": "--scope-scope---scope-scope",
    "content": "--scope <scope> /*--scope-scope*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#标志选项-flag-options",
  title: _jsx(_Fragment, {
    children: "标志选项 "
  })
}, {
  depth: 3,
  url: "#--api-url---api-url",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--api <url>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--yes---yes",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--yes"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--scope-scope---scope-scope",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--scope <scope>"
    }), " "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "将仓库链接到远程缓存提供程序。"
    }), "\n", _jsx(_components.p, {
      children: "¥Link the repository to a Remote Cache provider."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["选定的所有者（用户或组织）将能够通过 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), " 共享 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "缓存工件"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The selected owner (either a user or an organization) will be able to share ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "cache artifacts"
      }), " through ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "标志选项-flag-options",
      children: "标志选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Flag options"
    }), "\n", _jsxs(_components.h3, {
      id: "--api-url---api-url",
      children: [_jsx(_components.code, {
        children: "--api <url>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "指定远程缓存提供程序的 URL。"
    }), "\n", _jsx(_components.p, {
      children: "¥Specifies the URL of your Remote Cache provider."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --api=https://example.com"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--yes---yes",
      children: [_jsx(_components.code, {
        children: "--yes"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "对所有提示回答“是”"
    }), "\n", _jsx(_components.p, {
      children: "¥Answer yes to all prompts"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --yes"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--scope-scope---scope-scope",
      children: [_jsx(_components.code, {
        children: "--scope <scope>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "你要链接的范围。例如，在使用 Vercel 时，这是你的 Vercel 团队的 slug。"
    }), "\n", _jsx(_components.p, {
      children: "¥The scope to which you are linking. For example, when using Vercel, this is your Vercel team's slug."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --scope=your-team"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
